import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import styles from './DashboardPage.module.css';

const COLORS = ['#0f2444','#1a3a6b','#2d527a','#1a4a3a','#4a2d1a','#2d1a4a'];

export default function DashboardPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [asignaturas, setAsignaturas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/asignaturas')
      .then(r => setAsignaturas(r.data.data))
      .finally(() => setLoading(false));
  }, []);

  const hora = new Date().getHours();
  const saludo = hora < 13 ? 'Buenos días' : hora < 20 ? 'Buenas tardes' : 'Buenas noches';

  return (
    <div className={styles.page}>
      {/* Saludo */}
      <div className={styles.hero}>
        <div>
          <p className={styles.saludo}>{saludo},</p>
          <h2 className={styles.nombre}>{user?.nombre} {user?.apellidos}</h2>
          <p className={styles.info}>
            {user?.rol === 'profesor' ? 'Panel del profesorado' : 'Panel del alumnado'} ·{' '}
            {asignaturas.length} asignatura{asignaturas.length !== 1 ? 's' : ''}
          </p>
        </div>
      </div>

      {/* Grid de asignaturas */}
      <h3 className={styles.sectionTitle}>Mis asignaturas</h3>

      {loading ? (
        <p className={styles.loading}>Cargando...</p>
      ) : asignaturas.length === 0 ? (
        <p className={styles.empty}>No tienes asignaturas asignadas.</p>
      ) : (
        <div className={styles.grid}>
          {asignaturas.map((a, i) => (
            <div
              key={a.id}
              className={styles.card}
              style={{ '--accent': COLORS[i % COLORS.length] }}
              onClick={() => navigate(`/asignaturas/${a.id}`)}
            >
              <div className={styles.cardTop}>
                <span className={styles.codigo}>{a.codigo}</span>
                <span className={styles.curso}>Curso {a.curso}º · C{a.cuatrimestre}</span>
              </div>
              <h4 className={styles.cardTitle}>{a.nombre}</h4>
              {a.descripcion && <p className={styles.cardDesc}>{a.descripcion}</p>}
              <div className={styles.cardLinks}>
                {['anuncios','trabajos','calificaciones'].map(sec => (
                  <button key={sec} className={styles.pill}
                    onClick={e => { e.stopPropagation(); navigate(`/asignaturas/${a.id}/${sec}`); }}>
                    {sec.charAt(0).toUpperCase() + sec.slice(1)}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
